import { createSlice } from '@reduxjs/toolkit';
import { fetchTeacherHonorarium, fetchHonorariums, fetchHonorariumDetails } from '../thunks/honorariumThunks';

const initialState = {
  honorarium: [],
  pagination: {
    page: 1,
    limit: 10,
    total: 0,
    pages: 0
  },
  honorariums: [], 
  summary: null,
  loading: false,
  error: null,
};

const honorariumSlice = createSlice({
  name: 'honorarium',
  initialState,
  reducers: {
    clearHonorariumError: (state) => {
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTeacherHonorarium.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTeacherHonorarium.fulfilled, (state, action) => {
        const teacherHonorariumData = action.payload?.data || action.payload;
        state.loading = false;
        state.honorarium = teacherHonorariumData?.honorarium || [];
        state.pagination = teacherHonorariumData?.pagination || {
          page: 1,
          limit: 10,
          total: 0,
          pages: 0
        }
      })
      .addCase(fetchTeacherHonorarium.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchHonorariums.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchHonorariums.fulfilled, (state, action) => {
        state.loading = false;
        state.pagination = action.payload.data.pagination;
        state.honorariums = action.payload.data.honorariums;
        state.summary = action.payload.data.summary;
      })
      .addCase(fetchHonorariums.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchHonorariumDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchHonorariumDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedHonorarium = action.payload.data;
      })
      .addCase(fetchHonorariumDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export const honorariumAction = honorariumSlice.actions;
export const honorariumReducer = honorariumSlice.reducer;
